<template>
  <v-autocomplete
    v-model="empleado"
    :items="items"
    :loading="isLoading"
    :search-input.sync="search"
    no-filter
    item-text="nombreCompleto"
    item-value="numEmpleado"
    label="CURP o nombre"
    return-object
    dense
    hide-details
    clearable
    @input="selectEmpleado"
    @click:clear="clearEmpleado" 
  >
    <template v-slot:prepend-inner>
      <span v-if="isLoading" class="custom-loader">
        <v-icon>mdi-account-reactivate-outline</v-icon>
      </span>
      <span v-else>
        <v-icon>mdi-account-search-outline</v-icon>
      </span>
    </template>
    <template v-slot:item="data">
      <v-list-item-content>
        <v-list-item-title>{{data.item.nombreCompleto}}</v-list-item-title>
        <v-list-item-subtitle>{{data.item.area}}</v-list-item-subtitle>
      </v-list-item-content>
    </template>
  </v-autocomplete>
</template>

<script>
import axios from 'axios'

export default {
  props: {
    value: {type: Object}
  },
  data: () => ({
    items: [],
    isLoading: false,
    empleado: null,
    search: null,
    idTimeOut: 0,
    reloading: false
  }),
  watch: {
    search (val) {
      if (!val) return;

      if (val.length < 4) return;

      if (this.empleado && val === this.empleado.nombreCompleto) return

      if (this.idTimeOut) {
        clearTimeout(this.idTimeOut);
        this.isLoading = false;
        this.idTimeOut = 0;
      }
      this.idTimeOut = setTimeout(this.loadFromApi, 500, val);
    },
    value() {
      if (this.value || this.empleado) {
        if (this.value) {
          if (this.empleado && this.empleado.numEmpleado !== this.value.numEmpleado) {
            this.empleado = this.value;
            this.items = []
          }
        } else {
          this.empleado = this.value;
          this.items = []
        }
      }
    }
  },
  methods: {
    loadFromApi(query) {
      this.isLoading = true;
      axios.get(`/empleado?query=${query}`)
        .then(response => {
          this.items = response.data;
        })
        .catch(error => {
          console.log(error);
          if (error.response) {
            if (error.response.status === 401) {
              this.$router.push({name: 'Login'});
            }
          }
        })
        .finally(() => (this.isLoading = false));
    },
    selectEmpleado() {
      this.$emit("update:value", this.empleado);
    },
    clearEmpleado() {
      this.$emit("click:clear");
    }
  }
}
</script>

<style scoped>
  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
  }
  @-moz-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-webkit-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-o-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
</style>
